import * as React from 'react';
import * as moment from 'moment';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import Benefit from './components/Benefit';
import Signpost from './components/Signpost';
import { FormattedNumber } from 'react-intl';
import * as Commonmark from 'react-commonmark';
import { IStore } from '../../../../redux/IStore';
import Loading from '../../../../components/Loading';
import FaInfoCircle from 'react-icons/fa/info-circle';
import NoCoverAvailable from './components/NoCoverAvailable';
import { IAuthState } from '../../../../services/auth/models';
import SelectControl from '../../../../components/SelectControl';
import { II18nMessages } from '../../../../services/branding/models';
import FieldFormControl from '../../../../components/FieldFormControl';
import { recalculateScore } from '../../../../services/healix/reducer';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { IQuoteState, IQuoteActions } from '../../../../services/quote/models';
import AlternativeDatePicker from '../../../../components/AlternativeDatePicker';
import { isEmpty, flow, map, startCase, size, forEach, difference, values, get } from 'lodash';
import { isRequired, isFutureDate, isValidDate, annualLimit } from '../../../../util/validators';
import { IBenefit, IChannel, IPolicyApplication, IProduct } from '../../../../data/api/models';
import { EventWithDataHandler, Field, formValueSelector, InjectedFormProps, reduxForm, submit } from 'redux-form';
import { Button, Form, Row, Col, Modal, FormGroup, ControlLabel, OverlayTrigger, Popover } from 'react-bootstrap';
import MaxTripDuration from '../TripDetails/components/MaxTripDuration/MaxTripDuration';

// Auto-continue if it channel.key in the list

interface ISchemeChoiceFormProps extends InjectedFormProps {
  i18n: II18nMessages;
  quote: IQuoteState;
  application: IPolicyApplication;
  tripType: string;
  schemeId: string;
  startDate: string;
  password: string;
  passwordConfirmation: string;
  auth: IAuthState;
  endDate: string;
  pristine: boolean;
  submitting: boolean;
  region: string;
  maxTripDuration: string;
  dispatch: any;
  onBack: () => void;
  channel: IChannel;
  renderDefinition(name: string, defName?: string, icon?: string): any;
  recalculateScore(callback, screeningId, region, destinations);
  product: IProduct;
  actions: {
    submit(name: string);
    push: (route: string) => void;
    quote: IQuoteActions;
    getFormSubmitErrors: (formName: string) => void;
    getFormError: (formName: string) => any;
  };
}

interface ISchemeChoiceFormState {
  invalidFields: boolean;
  moreInfo: boolean;
  showUpSellModal: boolean;
  showSaveQuoteModal: boolean;
  isQuoteSaved: boolean;
  renderCoverChoicePage: boolean;
  columns: number;
  coverLevel: string;
  moreInfoSign: string;
}

class SchemeChoiceForm extends React.Component<ISchemeChoiceFormProps, ISchemeChoiceFormState> {
  public state = {
    invalidFields: false,
    moreInfo: false,
    showUpSellModal: false,
    showSaveQuoteModal: false,
    isQuoteSaved: false,
    renderCoverChoicePage: true,
    columns: 0,
    coverLevel: '',
    moreInfoSign: 'glyphicon-plus-sign',
  };

  public componentWillMount() {
    const { dispatch, schemeId, actions, change } = this.props;

    dispatch(change('steps', ['tripDetails', 'schemeChoice', 'declaration']));
    // dispatch(change('emailSend', false));

    if (schemeId) {
      dispatch(change('schemeId', ''));
      actions.quote.calculate(null, true);
    }
  }

  public componentWillReceiveProps(nextProps) {
    const { tripType, actions, quote } = this.props;

    // wrap func inside trip type so it doesn't break when retrieving a quote
    if (!tripType) {
      return;
    }

    let cols = 0;
    forEach(quote.quotes, (quotes) => {
      let benefitsKey = tripType;

      if (size(quotes) === 1) {
        benefitsKey = Object.keys(quotes)[0];
      }

      // check for errors/declines/referrals
      const hasError = benefitsKey && quotes[benefitsKey].errors.length > 0;
      const hasDeclines = quotes[benefitsKey].declines && quotes[benefitsKey].declines.length > 0;

      if (!hasError && !hasDeclines) {
        cols++;
      }
      const hasReferrals = quotes[benefitsKey].referrals && quotes[benefitsKey].referrals.length > 0;

      if (hasReferrals) {
        actions.quote.referralQuote(quote.application.id, quotes[benefitsKey].referrals);
      }

      if (hasReferrals) {
        this.setState({
          renderCoverChoicePage: false,
        });
      }
    });

    this.setState({
      renderCoverChoicePage: cols > 0,
      columns: cols,
    });
  }

  private handleSubmit = () => {
    const { change, dispatch, actions, region, maxTripDuration, product } = this.props;
    const annualTripDurations = Object.keys(get(product, 'metadata.annual_trip_durations', []));
    const checkMaxTrip = annualTripDurations.length > 1;

    // Don't close the modal if fields are invalid
    if (!region || (checkMaxTrip && !maxTripDuration)) {
      this.setState({
        invalidFields: true,
      });
      return;
    }

    dispatch(change('endDate', ''));
    dispatch(change('destinations', []));
    dispatch(change('tripType', 'annual'));

    setTimeout(() => {
      actions.quote.saveQuote(true);
      actions.submit('quote');
      this.setState({
        showUpSellModal: false,
      });
    }, 400);
  }

  private checkForUpSell = (checkSchemeId?: string) => {
    const { quote, schemeId: formSchemeId, actions, tripType, dispatch, change } = this.props;
    const schemeId = checkSchemeId ? checkSchemeId : formSchemeId;
    let shouldSubmit = false;

    forEach(quote.quotes, (quote) => {
      const annualQuote = quote && quote.annual && quote.annual;
      const singleQuote = quote && quote.single && quote.single;

      if (tripType === 'single' && schemeId === get(annualQuote, 'scheme.id')) {
        dispatch(change('region', annualQuote.information.region));
        this.setState({
          showUpSellModal: true,
          coverLevel: annualQuote.scheme.coverLevel,
        });
      }

      if (schemeId === singleQuote.scheme.id || tripType === 'annual') {
        shouldSubmit = true;
      }
    });

    if (shouldSubmit) {
      // I believe that this doesn't work initially because the form is pristine and this gets called
      // before this value is updated, so redux-form ignores the submit, so this allows time for
      // the form to finish validating and submit.
      setTimeout(() => {
        actions.submit('quote');
      }, 100);
    }
  }

  private closeUpSellModal = () => {
    const {change, dispatch } = this.props;
    dispatch(change('schemeId', ''));
    this.setState({
      showUpSellModal: false,
    });
  }

  private renderUpSellModal = () => {
    const { i18n, product } = this.props;
    const { coverLevel } = this.state;
    const modalTitle = 'Annual Multi-Trip';

    const popoverClickRootClose = (
      <Popover id="popover-trigger-click-root-close" title="Regions">
        <Commonmark source={product.metadata.definitions.region_uk} />
        <Commonmark source={product.metadata.definitions.region_europe} />
        <Commonmark source={product.metadata.definitions.region_worldwide_excluding} />
        <Commonmark source={product.metadata.definitions.region_worldwide} />
      </Popover>
    );

    const regionsList = map(product.metadata.regions, (name, key) => ({
      label: name,
      value: key,
    }));

    let maxTripDurationList = [];
    const maxTrips = get(product, 'metadata.max_trip_durations.' + coverLevel);
    if (maxTrips) {
      maxTripDurationList = map(maxTrips, (name, key) => ({
        label: name,
        value: key,
      }));
    } else {
      maxTripDurationList = map(product.metadata.annual_trip_durations,
          (name, key) => ({
        label: name,
        value: key,
      }));
    }

    const maxTripDefinition = product.metadata.definitions.max_trip_duration;
    const showMaxTripSelect = size(maxTripDurationList) > 1;

    // if (product.metadata.annual_trip_durations) {
    //   dispatch(change('maxTripDuration', Object.keys(product.metadata.annual_trip_durations)[0]));
    // }

    const advancedDays = 31;

    return (
      <Modal show={this.state.showUpSellModal} onHide={this.closeUpSellModal}>
        <Modal.Header closeButton={true}>
          <Modal.Title>Upgrading to {modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="section-group">
            <div className="section">
              Please confirm the region that you require cover for.
              <p>
                If your selected region differs from the region of your original
                destination, this may affect the premium:
              </p>
              <Row className="margin-top">
                <FormGroup controlId="destination">
                  <Col componentClass={ControlLabel} sm={3}>
                    {i18n.quote.tripDetails.region}{' '}
                    <OverlayTrigger
                      trigger="click"
                      rootClose={true}
                      placement="right"
                      overlay={popoverClickRootClose}
                    >
                      <FaInfoCircle />
                    </OverlayTrigger>
                  </Col>
                  <Col sm={9} className="destinations-inputs">
                    <Field
                      name="region"
                      type="text"
                      component={SelectControl}
                      options={regionsList}
                      validate={[
                        isRequired,
                      ]}
                    />
                  </Col>
                </FormGroup>
              </Row>
              <div className="margin-top">
                {showMaxTripSelect && (
                  <MaxTripDuration
                    isInvalid={this.state.invalidFields}
                    i18n={i18n}
                    options={maxTripDurationList}
                    definition={maxTripDefinition}
                    withPopover={true}
                  />
                )}
              </div>
            </div>
            <div className="section">
              <Row>
                <FormGroup controlId="start-date">
                  <Col componentClass={ControlLabel} xs={6}>
                    Start Date
                  </Col>
                  <Col sm={6}>
                    <div className="alternative-date-picker">
                      <div className="field">
                        <Field
                          name="startDate"
                          type="masked-date"
                          placeholder="dd/mm/yyyy"
                          component={FieldFormControl}
                        />
                      </div>
                      <div className="icon">
                        <Field
                          name="startDate"
                          maxDate={moment().add('90', 'days')}
                          component={AlternativeDatePicker}
                          validate={[ isRequired, isFutureDate, isValidDate, annualLimit(advancedDays) ]}
                        />
                      </div>
                    </div>
                  </Col>
                </FormGroup>
              </Row>
              <div className="important margin-top">
                <strong>IMPORTANT</strong> - Cancellation cover begins on the date you choose
                to start your policy. If you already have a trip booked and you want to be covered
                immediately, you should select today’s date. You can choose to start your policy
                later (up to 31 days from today’s date) but there would not be any cancellation
                cover between now and the start date you choose.
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="primary"
            type="submit"
            className="btn-remove-border"
            onClick={this.handleSubmit}
          >
            Continue
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  private getBenefit = (benefits: IBenefit[], displayName, type?, subBenefitName?) => {
    let displayBenefit = '';
    let displayBenefitDescription = '';
    let subBenefit = [];
    let displaySubBenefit = '';

    benefits.forEach((benefit) => {
      if (benefit.displayName === displayName || benefit.name === displayName) {
        subBenefit = benefit.subBenefits;
        displayBenefit = benefit.text;
        displayBenefitDescription = benefit.description;
      }
      forEach(subBenefit, (item) => {
        if (item.name === subBenefitName) {
          displaySubBenefit = item.text;
        }
      });
    });

    switch (type) {
      case 'subBenefit':
        return displaySubBenefit;
      case 'description':
        return displayBenefitDescription;
      default:
        return displayBenefit;
    }
  }

  private unableToProvideQuoteMessage = () => {
    const { channel } = this.props;
    const isOnList = ['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c', 'css-b2c', 'cssr-b2c']
        .includes(channel.key);

    if (isOnList) {
      return <span> Not available </span>;
    }

    return <span>Unable to quote online - please call {channel.phone}</span>;
  }

  private standardiseTheName = (name) => {
    if ('css_travel' === name) {
      return 'CSS Travel';
    }
    let formattedName = startCase(name.replace('_', ' '));
    // Work around to avoid scheme/cover level changes. Keep if purely cosmetic for this page other-wise will need
    // change in all the places.
    if (formattedName === 'Forces Pension Society') {
      formattedName = 'FPSTravelcover';
    }
    return formattedName;
  }

  private renderQuotes = () => {
    const { quote, product, tripType: tripTypeValue, schemeId, channel, maxTripDuration, region } = this.props;

    if (!tripTypeValue) {
      return null;
    }

    const { moreInfo, columns } = this.state;
    const quotes = quote.quotes;
    const breakingPoint = ['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c', 'css-b2c', 'cssr-b2c']
        .includes(channel.key)
        ? 9 : 12;
    const singleKey = 'single';
    const annualKey = 'annual';
    let orderedQuotes = product.metadata.scheme_order.map((order) => {
      if (quotes[order] !== undefined) {
        return quotes[order];
      }
    });

    // remove any undefined iterations in array
    orderedQuotes = orderedQuotes.filter((i) => {
      return i !== undefined;
    });

    // To avoid reading from undefined when navigating back to cover choice
    if (!orderedQuotes[0]) {
      return null;
    }

    const errors = [];

    orderedQuotes.forEach((tripTypes, level) => {
      // check for errors
      const hasError = tripTypes[tripTypeValue].errors.length > 0;
      const hasDeclines = tripTypes[tripTypeValue].declines.length > 0;
      const hasReferrals = tripTypes[tripTypeValue].referrals.length > 0;
      const unableToProvideQuote = hasError || hasDeclines || hasReferrals;
      if (unableToProvideQuote) {
        errors.push(level);
      }
    });

    if (errors.length === orderedQuotes.length) {
      return null;
    }

    return map(orderedQuotes, (tripTypes, level) => {
      const isSingleTrip = tripTypeValue === 'single';
      let displayAnnual = true;

      let benefitsKey = tripTypeValue;

      if (size(tripTypes) === 1) {
        benefitsKey = Object.keys(tripTypes)[0];
      }

      // define className if tripType = annual
      let containerClassName = tripTypes && tripTypes[benefitsKey].scheme.id === schemeId ?
        'quote-container active' : 'quote-container';

      if (isSingleTrip) {
        if (tripTypes[singleKey] && tripTypes[annualKey] &&
          tripTypes[annualKey].gross < tripTypes[singleKey].gross) {
          displayAnnual = false;
        }

        if (['cps-b2c'].includes(channel.key)) {
          displayAnnual = false;
        }

        containerClassName = (tripTypes && tripTypes[benefitsKey].scheme.id === schemeId) ||
          (tripTypes && annualKey && get(tripTypes, annualKey + '.scheme.id') === schemeId) ?
          'quote-container active' : 'quote-container';
      }

      const benefits = tripTypes && tripTypes[benefitsKey].benefits;
      const benefitsFlatten = this.flattenBenefits(benefits);

      if (!tripTypes) {
        return null;
      }

      // check for errors
      const hasError = tripTypes[benefitsKey].errors.length > 0;
      const hasDeclines = tripTypes[benefitsKey].declines.length > 0;
      const hasReferrals = tripTypes[benefitsKey].referrals.length > 0;
      const unableToProvideQuote = hasError || hasDeclines || hasReferrals;

      if (unableToProvideQuote) {
        return <div/>;
      }

      // check for up sell errors
      const hasAnnualError = get(tripTypes, annualKey + '.errors', []).length > 0;
      const hasAnnualDeclines = get(tripTypes, annualKey + '.declines', []).length > 0;
      const hasAnnualReferrals = get(tripTypes, annualKey + '.referrals', []).length > 0;
      const unableToProvideAnnualQuote = hasAnnualError || hasAnnualDeclines || hasAnnualReferrals;

      const renderValidation = !unableToProvideAnnualQuote;

      // Display the benefits container logic.
      const showBenefitsContainer = true;

      let selectQuoteBtnClass = ['select-quote-btn',
        ['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c', 'css-b2c', 'cssr-b2c']
            .includes(channel.key)
          ? 'label--noTransform' : ''].join(' ');
      let bootstrapCols = {
        0: 9,
        1: 9,
        2: 4,
        3: 3,
        4: 2,
      };

      // This is a conditional set of columns, need a more consistent fix
      const maxTripIncludes = [60, 90, 120].includes(maxTripDuration);
      if (channel.key === 'mpt-b2c' && maxTripIncludes) {
        bootstrapCols = {
          0: 8,
          1: 8,
          2: 4,
          3: 3,
          4: 2,
        };
      }

      if (['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'css-b2c', 'cssr-b2c', 'cspa-b2c', 'cspar-b2c']
          .includes(channel.key)) {
        selectQuoteBtnClass = ['select-quote-btn label--noTransform btn-remove-border'].join(' ');
        bootstrapCols = {
          0: 8,
          1: 8,
          2: 4,
          3: 3,
          4: 2,
        };
      }

      let coverLevel = tripTypes[benefitsKey].scheme.coverLevel;

      if (coverLevel === 'npo_travel') {
        coverLevel = 'NARPO Travel Insurance';
      }

      if (coverLevel === 'eurp_full_cover') {
        coverLevel = region;
      }

      if (coverLevel === 'css_travel') {
        coverLevel = 'Combined Services Travel Cover';
      }

      if (coverLevel === 'cspa_travel') {
        coverLevel = 'CSPA travel Insurance';
      }

      return (
        <Col sm={bootstrapCols[columns]} key={level}>
          <div className={containerClassName}>
            <div className="quote-header">
              <p className="cover-level">
                {this.standardiseTheName(coverLevel)}
              </p>
            </div>
            <div className="quote-body">
              {!unableToProvideQuote ? (
                <div>
                  <span className="scheme-type">
                  {benefitsKey}
                  </span>
                  <h1>
                    <FormattedNumber
                      value={tripTypes ? get(tripTypes, benefitsKey + '.gross', 0) : 0}
                      style="currency"
                      currency={tripTypes[benefitsKey].currency}
                    />
                  </h1>
                  <Field
                    name="schemeId"
                    type="radio"
                    value={tripTypes[benefitsKey].scheme.id}
                    className="select-quote"
                    component={FieldFormControl}
                    validate={[ isRequired ]}
                    onChange={this.handleSchemeIdChange}
                  >
                    <div className={selectQuoteBtnClass} >
                        {tripTypes[benefitsKey].scheme.id === schemeId ? 'Selected' : 'Continue'}
                    </div>
                  </Field>
                </div>
              ) : (
                <div>
                  {!['cps-b2c'].includes(channel.key) && (
                    this.unableToProvideQuoteMessage()
                  )}
                </div>
              )}
              {isSingleTrip && tripTypes[annualKey] && (
                <div>
                  {renderValidation && get(tripTypes, benefitsKey + '.gross', 0) !== 0
                  && displayAnnual
                      ? (
                    <div className="annual-quotes">
                       <span className="scheme-type">
                      {annualKey}
                      </span>
                      <h1>
                        <FormattedNumber
                          value={tripTypes ? tripTypes[annualKey].gross : 0}
                          style="currency"
                          currency={tripTypes[annualKey].currency}
                        />
                      </h1>
                      <Field
                        name="schemeId"
                        type="radio"
                        value={tripTypes[annualKey].scheme.id}
                        className="select-quote"
                        component={FieldFormControl}
                        validate={[ isRequired ]}
                        onChange={this.handleSchemeIdChange}
                      >
                        <div className={selectQuoteBtnClass} >
                          {tripTypes[annualKey].scheme.id === schemeId ? 'Selected' : 'Select'}
                        </div>
                      </Field>
                    </div>
                  ) : (
                    <div>
                      {!['cps-b2c'].includes(channel.key) && (
                        <div className="annual-quotes unable-quote-container">
                          {this.unableToProvideQuoteMessage()}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
              {!unableToProvideQuote && quote.signpost ?
                  <Row>
                    <Signpost signpost={quote.signpost} channel={channel}/>
                  </Row>
                  :
                  <div/>
              }
              {showBenefitsContainer ? (
              <Row className="benefit-section benefit-section--aligned">
                {['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c', 'css-b2c', 'cssr-b2c']
                    .includes(channel.key) && (
                  <Benefit
                    title={'Standard Excess'}
                    description={null}
                    value={get(tripTypes[benefitsKey], 'information.standardExcess')}
                  />
                )}
                {benefitsFlatten && benefitsFlatten.map((benefit, key) => {
                  if (key === breakingPoint) {
                    return (
                      <div key={key} id="view-document-section">
                        <Benefit
                          title={benefit.name}
                          description={this.getBenefit(benefitsFlatten, benefit.name, 'description')}
                          value={this.getBenefit(benefitsFlatten, benefit.name)}
                        />
                        <div className="view-document-container">
                          <div className="view-title">
                            Insurance Product Information Document
                          </div>
                          <Button
                            className="view-btn btn-remove-border" block={true}
                            onClick={this.downloadDocument(tripTypes[benefitsKey].scheme.documents)}
                          >
                            VIEW
                          </Button>
                        </div>
                        <div className="more-info-btn-container">
                          {['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c', 'css-b2c', 'cssr-b2c']
                              .includes(channel.key)
                              ? (
                              <Button
                                  type="button"
                                  className="btn-more-info btn-remove-border"
                                  onClick={this.toggleMoreInfo}>
                                { this.state.moreInfo ? (
                                  'Less Info'
                                ) : (
                                  'More Info'
                                )}
                              </Button>
                          ) : (
                            <span className={`glyphicon ${this.state.moreInfoSign}`} onClick={this.toggleMoreInfo} />
                          )}
                        </div>
                      </div>
                    );
                  }

                  if (key > breakingPoint) {
                    if (moreInfo) {
                      return (
                        <div>
                          <Benefit
                            key={key}
                            title={benefit.name}
                            description={this.getBenefit(benefitsFlatten, benefit.name, 'description')}
                            value={this.getBenefit(benefitsFlatten, benefit.name)}
                          />
                        </div>
                      );
                    }
                    return null;
                  }

                  return (
                    <Benefit
                      key={key}
                      title={benefit.name}
                      description={this.getBenefit(benefitsFlatten, benefit.name, 'description')}
                      value={this.getBenefit(benefitsFlatten, benefit.name)}
                    />
                  );
                })}
              </Row>) : null}
            </div>
          </div>
        </Col>
      );
    });
  }

  private toggleMoreInfo = () => {
    if (this.state.moreInfoSign === 'glyphicon-plus-sign') {
      this.setState((prevState) => ({
        moreInfoSign: 'glyphicon-minus-sign',
      }));
    } else {
      this.setState((prevState) => ({
        moreInfoSign: 'glyphicon-plus-sign',
      }));
    }

    this.setState((prevState) => ({
      moreInfo: !prevState.moreInfo,
    }));
  }

  private downloadDocument = (benefitsKey) => () => {
    const IPID = 'Insurance Product Information Document';
    const toDownload = benefitsKey[IPID];
    if (window) {
      window.open(toDownload, '_blank');
    }
  }

  /**
   * Return an array of Objects with subBenefits in the same level of
   * benefits with helper keys to identity if it is a subBenefit or a benefit.
   *  @param:  array: [{ name: 'Winter': { subBenefits: { name: 'Ski Pack' } }
   *  @return: array: [{ name: 'Winter', hasSubBenefits: true }, { name: 'Ski Pack', subkeyOf: 'Winter' }]
   */
  private flattenBenefits = (benefits) => {
    const benefitsFlatten = [];

    benefits.map((benefit) => {
      if (benefit.display !== false) {
        benefitsFlatten.push({
          name: benefit.name,
          text: benefit.text,
          hasSubBenefits: benefit.subBenefits && benefit.subBenefits.length > 0,
        });
      }
      if (!isEmpty(benefit.subBenefits)) {
        benefit.subBenefits.map((key) => {
          if (key.display !== false) {
            benefitsFlatten.push(
              {
                name: key.name,
                text: key.text,
                subkeyOf: benefit.name,
              },
            );
          }
        });
      }
    });
    return benefitsFlatten;
  }

  private renderLeftSideHelper = () => {
    const { quote, tripType, renderDefinition, channel, product } = this.props;
    const { moreInfo } = this.state;
    const quotes = quote.quotes;
    let keyReference = Object.keys(quotes)[0];

    // Get the first ObjectKey e.g.(super/essential) to use as a reference to list the benefits labels
    if (values(quotes).length >= 2) {
      keyReference = Object.keys(quotes)[1];
      // const keyReference2 = Object.keys(quotes)[0];
    }

    const benefits = quote.quotes[keyReference][tripType].benefits;

    // Fall Back Temp Fix
    // if (benefits && benefits.length === 0) {
    //   benefits = quote.quotes[keyReference2][tripType].benefits;
    // }

    const benefitsFlatten = this.flattenBenefits(benefits);

    let tripTypeDefinition = 'trip_type_single';
    if (tripType === 'annual') {
      tripTypeDefinition = 'trip_type';
    }
    const tripTypeArrow = ['trip-type-arrow', tripType === 'annual' ? 'trip-type-arrow--annual' : ''];

    if (['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c', 'css-b2c', 'cssr-b2c']
            .includes(channel.key) &&
        tripType !== 'annual') {
      tripTypeArrow.push('trip-type-arrow--tpl');
    }

    const tripTypeArrowClass = tripTypeArrow.join(' ');

    const hasExtraColumn = values(quotes).length >= 2; // hasExtraColumn ? 3 : 4}
    let renderAnnualTitle = ['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c']
        .includes(channel.key)
        ? 'Annual Multi-Trip' : 'Annual Multi-Trip Cover';
    const renderSingleTile = [''].includes(channel.key)
        ? 'Single Trip Cover' : 'Single Cover';
    // const isSpace = ['tpl-b2c', 'mpt-b2c'].includes(channel.key);
    // const space = [isSpace ? '' : 'more-info-space'].join(' ');
    let divCheck = 0;

    if (document.getElementById('signpost-quote-div')) {
      divCheck = document.getElementById('signpost-quote-div').offsetHeight + 20;
    }
    const breakingPoint = ['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c', 'css-b2c', 'cssr-b2c']
        .includes(channel.key)
        ? 9 : 12;

    if (!['npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c']
        .includes(channel.key)) {
      renderAnnualTitle = product.metadata.trip_type.annual;
    }

    if (['fps-b2c', 'fpr-b2c'].includes(channel.key)) {
      renderAnnualTitle = quote.application.region === 'europe' ? 'AMT Europe' : 'AMT Worldwide';
    }

    return (
      <Col xs={hasExtraColumn ? 3 : 4}>
        <div className="quote-helper">
          <div className="trip-type-container">
            <div className={tripTypeArrowClass + '--single'}>
              {renderDefinition(tripTypeDefinition, null, 'FaInfo')}
              {tripType === 'single' ? renderSingleTile : renderAnnualTitle}
            </div>
          </div>
          {tripType === 'single' && product.metadata.trip_type.annual && (
            <div className="trip-type-container">
              <div className={tripTypeArrowClass}>
                {renderDefinition('trip_type', null, 'FaInfo')}
                {renderAnnualTitle}
              </div>
            </div>
          )}
          {!!quote.signpost  && (<div className={'signpost-quote-container'} style={{ height: divCheck }} />)}
          {['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c', 'css-b2c', 'cssr-b2c']
              .includes(channel.key) && (
            <div className="benefit-container">
              <p className="benefit-title--strong" >
                Standard Excess
              </p>
            </div>
          )}
          {benefitsFlatten.map((benefit, key) => {
            const classname = [
              'benefit-title',
              'benefit-title--strong',
              benefit.subkeyOf && 'benefit-title--subkey',
            ].join(' ');
            const isWinterSports = benefit.name === 'Winter Sports';

            if (key === breakingPoint) {
              return (
                <div key={key} >
                  <div className="benefit-container">
                    <p className={classname} >
                      {benefit.name}
                    </p>
                  </div>
                  <div className="benefit-container">
                    <p className={`benefit-title-top ${classname}`}>
                      Insurance Product Information Document
                    </p>
                  </div>
                    <p className={classname}>
                      View full details
                    </p>
                  {/*<div className={space} />*/}
                </div>
              );
            }

            if (key > breakingPoint) {
              if (moreInfo) {
                return (
                  <div key={key} className="benefit-container">
                    <p className={classname} >
                      {benefit.name} {isWinterSports && '*'}
                    </p>
                  </div>
                );
              }
              return null;
            }
            return (
              <div key={key} className="benefit-container">
                <p className={classname} >
                  {benefit.name}
                </p>
              </div>
            );
          })}
        </div>
      </Col>
    );
  }

  private handleSchemeIdChange: EventWithDataHandler<Event> = (event, newValue) => {
    const { dispatch, change, actions, channel } = this.props;

    // FPS has only annual, e.g. no upsell.
    if (['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c', 'css-b2c', 'cssr-b2c']
        .includes(channel.key)) {
      dispatch(change('schemeId', newValue));
      setTimeout(() => {
        actions.submit('quote');
      }, 100);
    } else {
      // Because check for upsell causes a submit, this ensures that the value is in the redux form store
      // before it is submitted. Otherwise it will be updated after this function call finishes.
      event.preventDefault();
      dispatch(change('schemeId', newValue));
      this.checkForUpSell(newValue);
    }
  }

  public renderLoader() {
    return (
      <div className="schemes-loader text-center">
        <Loading />
        <p>
          Please wait whilst we generate your premiums...
        </p>
      </div>
    );
  }

  public render() {
    const {
      handleSubmit,
      quote,
      channel,
      product,
      tripType: tripTypeValue,
      onBack } = this.props;
    const { renderCoverChoicePage, moreInfo } = this.state;
    const quotes = quote.quotes;
    const noAvailableQuotes = isEmpty(quotes);
    const callMessage = {
      free: 'Simply call our UK-based specialist customer service team FREE on',
      cost: 'Simply call our UK-based specialist customer service team on',
    };
    const productCallMessage = {
      FST: callMessage.free,
      DIA: callMessage.cost,
      ADV: callMessage.cost,
      PST: callMessage.cost,
      CPS: callMessage.cost,
      EURP: callMessage.cost,
      CSIS: callMessage.cost,
    };
    const renderCallMessage = productCallMessage[product.productCode];
    const hasFinishedCalculation = values(quotes).length >= 1;

    if (quote.isCalculating) {
      return this.renderLoader();
    }

    const displayMoreInfo = tripTypeValue === 'single' && channel.key === 'mpt-b2c';
    const coverChoices = this.renderQuotes();
    let excess = '£95';
    if (['NPO', 'NPOR', 'CSPA', 'CSPAR', 'FPS', 'FPR'].includes(product.productCode)) {
      excess = '£75';
    } else if (['CSS', 'CSSR'].includes(product.productCode)) {
      excess = '£75';
    }

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        {!noAvailableQuotes ? (
          <div className="scheme-choice-section">
            <div className="section-title">
              <h3>Cover choice</h3>
            </div>

            <div className="available-quotes">
              {renderCoverChoicePage && coverChoices ? (
                <Row>
                  {hasFinishedCalculation && this.renderLeftSideHelper()}
                  {hasFinishedCalculation && coverChoices}
                  {moreInfo && displayMoreInfo && (
                    <Col sm={12}>
                      <p>
                        *Winter Sports cover is only in force if shown on your Policy
                        Schedule and the appropriate additional premium is paid.
                      </p>
                    </Col>
                  )}
                  <Col sm={12}>
                    <p>
                      <b>Please note:</b> all benefits are subject to {excess} excess except those marked with an
                      asterisk (*) The benefit marked with a cross (+) is subject to {excess} excess unless a European
                      Health Insurance Card or Global Health Insurance Card is used. Benefits are subject to conditions,
                      limitations and exclusions detailed in the membership agreement.
                    </p>
                  </Col>
                </Row>
              ) : (
                <div className="unable-box">
                  <NoCoverAvailable
                      promptSingleQuote={tripTypeValue === 'single'}
                      channel={channel}
                      quoteReference={quote.application.quoteReference}
                      callMessage={renderCallMessage}
                      signpost={quote.signpost}
                  />
                </div>
              )}
            </div>

            {renderCoverChoicePage && coverChoices && (
              <div className="btn-bar">
                <Button type="button" className="btn-back" onClick={onBack}>
                    Back
                </Button>
              </div>
            )}

            {this.renderUpSellModal()}
          </div>
        ) : (
          <div className="steps-container unable-box">
            <h1>Sorry, we are unable to provide you with a quote</h1>
          </div>
        )}
      </Form>
    );
  }
}

let selector;
let previousValues;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    onChange: (
      values: IPolicyApplication,
      dispatch,
      props: ISchemeChoiceFormProps,
    ) => {
      if (! previousValues) {
        previousValues = values;
        return;
      }

      let recalculateScore = false;

      if (difference(values.destinations, previousValues.destinations).length > 0) {
        recalculateScore = true;
      }

      if (values.region !== previousValues.region) {
        recalculateScore = true;
      }

      if (recalculateScore) {
        props.actions.quote.recalculateScreening();
      }

      previousValues = values;
    },
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const quote = state.quote;
      const tripType = selector(state, 'tripType');
      const maxTripDuration = selector(state, 'maxTripDuration');
      const schemeId = selector(state, 'schemeId');
      const startDate = selector(state, 'startDate');
      const endDate = selector(state, 'endDate');
      const travellers = selector(state, 'travellers');
      const region = selector(state, 'region');
      const password = selector(state, 'password');
      const passwordConfirmation =  selector(state, 'passwordConfirmation');
      const steps =  selector(state, 'steps');

      return {
        quote,
        tripType,
        schemeId,
        startDate,
        endDate,
        travellers,
        region,
        password,
        passwordConfirmation,
        maxTripDuration,
        steps,
        auth: state.auth,
        channel: state.branding.channel,
      };
    },
    (dispatch) => ({
      actions: {
        dispatch,
        submit: bindActionCreators(submit, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
        push: bindActionCreators(push, dispatch),
        recalculateScore: bindActionCreators(recalculateScore, dispatch),
      },
    }),
  ),
])(SchemeChoiceForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/SchemeChoice/index.tsx